import type { ClientEvent as ClientEventV2 } from '../proto/v2/client_event';
import type { TaskEventOptions } from '../config/types';

import { Base } from '../proto/base';
import { ClientEvent as ClientEventV3 } from '../proto/v3/client_event';

export default (options: TaskEventOptions, isV2: boolean = false): ClientEventV3.EventPackage | ClientEventV2.EventPackage => {
    const {
        sessionId,
        currentUrlPackage,
        referUrlPackage,
        name,
        params,
        type,
        contentPackage,
        status,
        taskType,
        operationDirection,
    } = options;
    const commonInfo = {
        url_package: currentUrlPackage,
        refer_url_package: referUrlPackage,
        element_package: {
            [isV2 ? 'action2': 'action']: name,
            params: JSON.stringify(params),
        },
        [isV2 ? 'content_wrapper' : 'content_package']: contentPackage
    }
    if (isV2) {
        // v2 click_event 是一个单独的事件类型，v3 则属于 task_event
        const isV2Click = taskType === 'USER_OPERATION' || type === 'CLICK' && !taskType;
        const operationType = type && Base.OperationType[type as keyof typeof Base.OperationType] || Base.OperationType.CLICK;
        if (isV2Click) {
            return {
                click_event: {
                    type: operationType,
                    direction: operationDirection && Base.Direction[operationDirection] || Base.Direction.UNKNOWN2,
                    ...commonInfo,
                }
            }
        }
        return {
            task_event: {
                action2: name,
                status: status && Base.TaskStatus[status] || Base.TaskStatus.UNKNOWN_STATUS,
                ...commonInfo,
            }
        }
    }
    return {
        task_event: {
            type: taskType && ClientEventV3.TaskEventType[taskType as keyof typeof ClientEventV3.TaskEventType] || ClientEventV3.TaskEventType.USER_OPERATION,
            status: status && Base.TaskStatus[status] || Base.TaskStatus.UNKNOWN_STATUS,
            operation_type: Base.OperationType[type] || Base.OperationType.CLICK,
            operation_direction: operationDirection && Base.Direction[operationDirection] || Base.Direction.UNKNOWN2,
            session_id: sessionId,
            ...commonInfo
        }
    }
}